import * as tslib_1 from "tslib";
import { observable, action, computed } from 'mobx';
import { green500, orange600, red500 } from 'material-ui/styles/colors';
import TaskApi from '../services/TaskApi';
var CheckListItem = /** @class */ (function () {
    function CheckListItem(dto) {
        this.id = dto.id;
        this.headId = dto.headId;
        this.name = dto.name;
        this.note = dto.note;
        this.insertDate = dto.insertDate;
        this.modifyDate = dto.modifyDate;
        this.statusId = dto.statusId;
        this.userId = dto.userId;
    }
    Object.defineProperty(CheckListItem.prototype, "color", {
        get: function () {
            switch (this.statusId) {
                case 3: return green500;
                case 5: return red500;
                default: return orange600;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckListItem.prototype, "icon", {
        get: function () {
            switch (this.statusId) {
                case 3: return 'check_circle';
                case 5: return 'remove_circle';
                default: return 'remove_circle';
            }
        },
        enumerable: true,
        configurable: true
    });
    CheckListItem.prototype.setStatus = function (statusId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.statusId = parseInt(statusId, 10);
                        return [4 /*yield*/, TaskApi.updateCheckListItem(this)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckListItem.prototype.setNote = function (note) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.note = note;
                        return [4 /*yield*/, TaskApi.updateCheckListItem(this)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        observable
    ], CheckListItem.prototype, "statusId", void 0);
    tslib_1.__decorate([
        computed
    ], CheckListItem.prototype, "color", null);
    tslib_1.__decorate([
        computed
    ], CheckListItem.prototype, "icon", null);
    tslib_1.__decorate([
        action
    ], CheckListItem.prototype, "setStatus", null);
    tslib_1.__decorate([
        action
    ], CheckListItem.prototype, "setNote", null);
    return CheckListItem;
}());
export default CheckListItem;



//////////////////
// WEBPACK FOOTER
// ./src/models/CheckListItem.ts
// module id = 346
// module chunks = 0